class FormHandler {
  constructor(component) {
    this.nonce = COBP_AJAX_NONCE;
    this.url = COBP_AJAX_URL;
    this.action = 'cobp_send_email';

    this.inputData = [];

    this.component = component;

    this.form = component.querySelector('.form');
    this.spin = component.querySelector('.spinner');
    this.comp = component.querySelector('.completion-text');

    this.form.addEventListener('submit', this.handle.bind(this));
  }

  async handle(e) {
    e.preventDefault();
    this.collectInputData();
    this.updateStatus(2);

    const res = await this.makeRequest();
    switch (res.status) {
      case 200:
        this.updateStatus(3);
        break;
      case 400:
        this.handleError(res);
        this.updateStatus(3);
        break;
    }
  }

  collectInputData() {
    const groups = this.form.querySelectorAll('.wp-block-cobp-form-input');

    this.inputData = [...groups].map((group) => {
      return {
        label: group.dataset.label,
        identifier: group.dataset.identifier,
        value: group.querySelector('input').value,
      };
    });
  }

  async makeRequest() {
    const FD = new FormData();

    FD.append('action', this.action);
    FD.append('nonce', this.nonce);
    FD.append('form_name', this.form.dataset.name);

    this.inputData.forEach((input) =>
      FD.append(
        input.label.length > 0 ? input.label : input.identifier,
        input.value
      )
    );

    return await fetch(this.url, {
      method: 'POST',
      body: FD,
      credentials: 'same-origin',
    }).then((res) => res.json());
  }

  updateStatus(status) {
    this.component.dataset.status = status;
  }

  handleError(res) {
    const heading = this.comp.querySelector('.heading');
    const body = this.comp.querySelector('.body');

    heading.innerText = 'THERE HAS BEEN AN ERROR';
    body.innerHTML =
      "<p>We're sorry for the inconvenience, please try again later.</p>";

    /* eslint-disable-next-line no-console */
    console.error('Form Error:', res);
  }
}

export { FormHandler };
